import { newStepValue } from '../../../../services/flowBuilder/utils/constants';

const endSessionTrue = {
  json: {
    menu: {
      menuType: 'displayMenu',
      text: '',
      menuParams: {
        endSession: true,
      },
    },
    metadata: {},
    type: 'menu',
  },
  paths: ['menu.text', 'menu.menuParams.endSession'],
  groups: [
    {
      Parameters: ['menu.text', 'menu.menuParams.endSession'],
    },
  ],
};

const endSessionFalse = {
  json: {
    menu: {
      menuType: 'displayMenu',
      text: '',
      menuParams: {
        endSession: false,
      },
    },
    type: 'menu',
    next: newStepValue,
    metadata: {},
  },
  paths: ['menu.text', 'menu.menuParams.endSession', 'next'],
  groups: [
    {
      Parameters: ['menu.text', 'menu.menuParams.endSession'],
    },
    {
      Logic: ['next'],
    },
  ],
};

export const displayMenu = {
  json: {
    menu: {
      menuType: 'displayMenu',
      text: '',
      menuParams: {
        endSession: true,
      },
    },
    type: 'menu',
    metadata: {},
  },
  paths: ['menu.text', 'menu.menuParams.endSession'],
  groups: [
    {
      Parameters: ['menu.text', 'menu.menuParams.endSession'],
    }
  ],
  layout: {
    text: {
      type: 'textarea',
      label: 'Menu Text',
      validators: {
        required: true,
        noSpacesNoText: true,
      },
    },
    endSession: {
      type: 'checkbox-single',
      label: 'End Session',
      attributes: {
        options: {
          true: 'true',
          false: 'false',
        },
        data: true,
      },
    },
    next: {
      type: 'next',
      label: 'Point to',
      validators: {
        optionSelected: true,
      },
    },
  },
  data: {
    dataPath: 'menu.menuParams.endSession',
    endSession: {
      true: endSessionTrue,
      false: endSessionFalse,
    },
  },
};
